import EntryHydrator from '@/data/entry-hydrator'
import EntryRepository from '@/data/entry-repository'
import { downloadFile } from '../Helpers'

/**
 * Utility to export all entries from the store
 */

const runExport = async (parentId?: string): Promise<void> => {
    // attempt to update all the entries
    try {
        await EntryHydrator.start()
    } catch (err) {
        // it's ok if we can't update the data,
        // we'll just export what we have
    }
    const entries = parentId
        ? [await EntryRepository.fetch(parentId)]
        : await EntryRepository.fetchTopLevelEntries()

    // transform all into export objects
    const entriesForExport = await Promise.all(entries.map(entry => entry.asExportedObject()))

    // done!
    downloadFile(`volt_export_${Date.now()}.vpx`, JSON.stringify(entriesForExport))
}

export default runExport
